import './rum';
// OpenReplay disabled for now (was a trial); re-enable by restoring this import and the code in ./openreplay.ts
// import './openreplay';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store';
import App from './App';
import './index.css';
import { Amplify } from "aws-amplify"

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_ADMIN_COGNITO_USER_POOL_ID, // Your User Pool ID
      identityPoolId: import.meta.env.VITE_ADMIN_COGNITO_IDENTITY_POOL_ID, // Your Identity Pool ID
      userPoolClientId: import.meta.env.VITE_ADMIN_COGNITO_CLIENT_ID,
    }
  },
  Storage: {
    S3: {
      bucket: import.meta.env.VITE_BUCKET_NAME,
      region: import.meta.env.VITE_REGION
    }
  },
})
ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
